import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SubmitInvoiceParams } from "../types/SubmitInvoiceParams";
import { UpdatePurchaseOrderResult } from "../types/UpdatePurchaseOrderResult";

export const useSubmitInvoice = (params: SubmitInvoiceParams) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("purchase-order/submit-invoice",
				{ invoice: params.invoice, products: params.products }) as UpdatePurchaseOrderResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				params.onSuccess(result);
			else
				params.onError('Error when submitting invoice: ' + result.errorMessage!);
		},
		onError(error) {
			params.onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
